import { numberOr } from "./money";

const unitLabel = (spanType, plural) => {
  if (spanType === "D") return plural ? "days" : "day";
  return plural ? "hours" : "hour";
};

export const buildEtaText = (dto) => {
  if (dto?.deliveryTimeText) return dto.deliveryTimeText;

  const minSpan = numberOr(dto?.minSpan);
  const maxSpan = numberOr(dto?.maxSpan);
  const spanType = dto?.spanType || null;

  if (dto?.consumerPickup) return "Collect at your convenience";
  if (minSpan === null && maxSpan === null) return "";

  if (minSpan !== null && maxSpan !== null) {
    if (minSpan === maxSpan) {
      return `Within ${maxSpan} ${unitLabel(spanType, maxSpan !== 1)}`;
    }
    return `${minSpan} to ${maxSpan} ${unitLabel(spanType, true)}`;
  }

  const span = maxSpan ?? minSpan;

  return `Within ${span} ${unitLabel(spanType, span !== 1)}`;
};

export const mapDeliveryTypeOption = (row) => {
  const dto = row?.deliveryType || row;

  if (!dto?.id) return null;

  const unsupportedProductIds = row?.unsupportedProducts || [];
  const supportedProductIds = row?.supportedProducts || [];

  return {
    id: dto.id,
    code: dto.code ?? null,
    title: dto.defaultTitle ?? "",
    description: dto.description ?? null,
    etaText: buildEtaText(dto),
    consumerPickup: dto.consumerPickup === true,
    scheduled: dto.scheduled === true,
    spanType: dto.spanType ?? null,
    minSpan: numberOr(dto.minSpan),
    maxSpan: numberOr(dto.maxSpan),
    gracePeriodHours: numberOr(dto.gracePeriodHours),
    supportedProductIds,
    unsupportedProductIds,
    supportsWholeCart: unsupportedProductIds.length === 0,
  };
};

export const mapDeliveryTypesResponse = (data) => {
  const rows = data?.deliveryTypes || data?.content || (Array.isArray(data) ? data : []);

  return rows.map(mapDeliveryTypeOption).filter(Boolean);
};

export const optionKey = (option) => option?.code || String(option?.id);

export const sharedDeliveryOptions = (optionsByCart) => {
  const lists = (optionsByCart || []).filter((list) => Array.isArray(list));
  const [first, ...rest] = lists;

  if (!first) return [];

  return first
    .filter((option) =>
      rest.every((list) => list.some((row) => optionKey(row) === optionKey(option)))
    )
    .map((option) => {
      const peers = lists
        .map((list) => list.find((row) => optionKey(row) === optionKey(option)))
        .filter(Boolean);

      return {
        ...option,
        supportedProductIds: peers.flatMap((peer) => peer.supportedProductIds),
        unsupportedProductIds: peers.flatMap((peer) => peer.unsupportedProductIds),
        supportsWholeCart: peers.every((peer) => peer.supportsWholeCart),
      };
    });
};
